import React, { useState } from 'react';
import { IconButton, Typography } from '@mui/material';
import { VisibilityOff } from '@material-ui/icons';

const SensitiveImages = (props) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleMouseDownFront = () => setIsVisible(true);
    const handleMouseUpFront = () => setIsVisible(false);

    if (!props.document.DocumentFront && !props.document.DocumentBack) {
        return <></>;
    }

    return (
        <div style={{ textAlign: 'center', marginBottom: '5%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div
                    onMouseDown={handleMouseDownFront}
                    onMouseUp={handleMouseUpFront}
                    onMouseLeave={handleMouseUpFront}
                    style={{ margin: '0 20px' }}
                >
                    {isVisible ? (
                        <>
                            {props.document.DocumentFront && <img
                                style={{
                                    width: '40%',
                                    marginBottom: '20px',
                                    paddingLeft: '20px',
                                    paddingRight: '20px',
                                }}
                                src={props.document.DocumentFront}
                                alt="Document Front"
                            />}
                            {props.document.DocumentBack && <img
                                style={{
                                    width: '40%',
                                    marginBottom: '20px',
                                    paddingLeft: '20px',
                                    paddingRight: '20px',
                                }}
                                src={props.document.DocumentBack}
                                alt="Document Back"
                            />}
                        </>
                    ) : (
                        <div>
                            <IconButton title="Hold left click to view" style={{ marginLeft: 0 }}>
                                <VisibilityOff style={{ fontSize: 50 }} />
                            </IconButton>
                            <Typography variant="body2" style={{ marginTop: '10px' }}>
                                Click and hold to view photos
                            </Typography>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SensitiveImages;
